<template>
    <el-button type="warning">批量添加教师</el-button>
    <hr>
    <div class="container">
      <el-row :gutter="20">
      <el-col :span="12">
          <el-icon><Download /></el-icon>下载模版: 
          <el-button type="success" @click="download();" plain>
              <img src="@/assets/img/card/excle.png" style="width: 30px">
              用户模版
          </el-button>
          
      </el-col>
      <el-col :span="3">
          <el-icon><Upload /></el-icon>上传模版:
      </el-col>
      <el-col :span="5">
          <input class="form-control" type="file" id="file" />
      </el-col>
      <el-col :span="4">
          <el-button type="success" @click="importStudent();" plain>导入教师</el-button>
      </el-col>
    </el-row>
      
  
    <h6 style="font-weight:bold;">示例:</h6>
    <el-table :data="tableData" border style="width: 100%;">
      <el-table-column prop="userName" label="用户名*" width="180" />
      <el-table-column prop="password" label="密码*" width="180" />
      <el-table-column prop="nickName" label="昵称*" />
      <el-table-column prop="gender" label="性别*" />
    </el-table>
  
  
    <div v-if="failData != null">
      <h6 style="font-weight:bold;">失败数据:</h6>
      <download-excel 
              :fields="dataStandard"
              :data = "failData"
              name = "部分失败用户.xls">
              <el-button type="primary" size="small">导出</el-button>
          </download-excel>
      <el-table :data="failData" border style="width: 100%;">
          <el-table-column prop="userName" label="用户名*" width="180" />
          <el-table-column prop="password" label="密码*" width="180" />
          <el-table-column prop="nickName" label="昵称*" />
          <el-table-column prop="gender" label="性别*" />
      </el-table>
      </div>
    </div>
  </template>
  
  <script setup>
  import $ from 'jquery';
  import { ElMessage, ElLoading } from "element-plus";
  import { ref } from 'vue';
  
  
  const link = "https://mircopro.oss-cn-shanghai.aliyuncs.com/mirco/options/template/%E7%94%A8%E6%88%B7%E6%A8%A1%E7%89%88.xlsx";
  
  const download = () => {
    const element = document.createElement('a');
    element.setAttribute('href', link);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
  
  const tableData = [
    {
      userName: 'HIU_2031796',
      password: '123456',
      nickName: '张XX',
      gender: '男'
    },
    {
      userName: 'HIU_2031111',
      password: '123XX113',
      nickName: '李XX',
      gender: '女'
    },
    {
      userName: ' ',
      password: ' ',
      nickName: ' ',
      gender: ' '
    },
    {
      userName: ' ',
      password: ' ',
      nickName: ' ',
      gender: ' '
    },
    {
      userName: '...',
      password: '...',
      nickName: '...',
      gender: '...'
    },
  ]
  
  const dataStandard = {
      "用户名" : "userName",
      "密码" : "password",
      "昵称" : "nickName",
      "性别" : "gender",
  }
  
  const failData = ref(null);
  
  
  const importStudent = () => {
    // 判断表格
    if ($("#file")[0].files.length == 0) {
      ElMessage({
        type: "error",
        message: "表格未上传！",
      });
      return false;
    }
  
  
    var formData = new FormData();
    formData.append("file", $("#file")[0].files[0]); // 表格
  
    
    const loading = ElLoading.service({
      lock: true,
      text: 'Loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
  
  
  
    const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/user/BatchAddTea",
        type: "post",
        data: formData,
        headers: {
          Authorization: "Bearer " + token,
        },
        processData: false, // 告诉jQuery不要去处理发送的数据
        contentType: false, // 告诉jQuery不要去设置Content-Type请求头
        dataType: "text",
        success: function (resp) {
          let result = JSON.parse(resp);
          if (result.code == "200") {
            ElMessage({
              type: "success",
              message: result.msg,
            });
            location.reload();
          } else {
            ElMessage({
              type: "error",
              message: result.msg,
            });
            failData.value = result.data;
            console.log(result.data);
            console.log(failData.value);
          }
          loading.close();
        },
        error: function () {
          ElMessage({
            type: "error",
            message: "导入学生失败！",
          });
          loading.close();
        },
      });
  }
  
  </script>
  
  <style>
  </style>